import { render, staticRenderFns } from "./SchemeDetails.vue?vue&type=template&id=6ffa2e9f&"
import script from "./SchemeDetails.vue?vue&type=script&lang=js&"
export * from "./SchemeDetails.vue?vue&type=script&lang=js&"
import style0 from "./SchemeDetails.vue?vue&type=style&index=0&id=6ffa2e9f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VIcon,VSimpleTable})
